// extracted by mini-css-extract-plugin
module.exports = {"searchText":"List_searchText_2vNQQ"};